import pdf from "./styles/img/PDF.svg";
import doc from "./styles/img/DOC.svg";
import flv from "./styles/img/FLV.svg";
import png from "./styles/img/PNG.svg";
import ppt from "./styles/img/PPT.svg";
import txt from "./styles/img/TXT.svg";
import xsl from "./styles/img/XSL.svg";
import zip from "./styles/img/ZIP.svg";
import other from "./styles/img/Other.svg";

export const selectLogo = (file_type) => {
  const file_type_ = file_type.toLowerCase();
  console.log(file_type_);
  switch (file_type_) {
    case "pdf":
      return pdf;
    case "doc":
      return doc;
    case "docx":
      return doc;
    case "dot":
      return doc;
    case "dotx":
      return doc;
    case "odt":
      return doc;
    case "rtf":
      return doc;
    case "wpd":
      return doc;
    case "flv":
      return flv;
    case "mp4":
      return flv;
    case "mov":
      return flv;
    case "wmv":
      return flv;
    case "avi":
      return flv;
    case "avchd":
      return flv;
    case "f4v":
      return flv;
    case "png":
      return png;
    case "swf":
      return png;
    case "mkv":
      return png;
    case "jpeg":
      return png;
    case "jpg":
      return png;
    case "gif":
      return png;
    case "tiff":
      return png;
    case "ppt":
      return ppt;
    case "pptx":
      return ppt;
    case "txt":
      return txt;
    case "xls":
      return xsl;
    case "xsl":
      return xsl;
    case "xlsx":
      return xsl;
    case "xlsm":
      return xsl;
    case "xlxb":
      return xsl;
    case "xltx":
      return xsl;
    case "zipx":
      return zip;
    case "rar":
      return zip;
    case "7z":
      return zip;
    case "gz":
      return zip;
    case "zip":
      return zip;
    default:
      return other;
  }
};
